import { apiRequest } from './client';

export interface DeliveryPricing {
  baseFee: number;
  pricePerKm: number;
  freeKm: number;
  roundTrip: boolean;
  depotZip: string;
  depotCity: string;
}

export interface DeliveryCalculation {
  found: boolean;
  estimated: boolean;
  insideServiceArea: boolean;
  place: string;
  county: string | null;
  zip: string | null;
  distanceKm: number | null;
  roundTrip: boolean;
  chargedKm: number | null;
  freeKm: number;
  chargeableKm: number | null;
  baseFee: number;
  pricePerKm: number;
  kmFee: number | null;
  deliveryFee: number | null;
  message: string;
}

export interface ZipDistance {
  id: string;
  zip: string;
  isPrefix: boolean;
  city: string;
  county: string;
  distanceKm: number;
  insideServiceArea: boolean;
}

export interface ZipDistanceInput {
  zip: string;
  city: string;
  county: string;
  distanceKm: number;
  insideServiceArea: boolean;
}

export const calculateDelivery = (query: string): Promise<DeliveryCalculation> =>
  apiRequest<DeliveryCalculation>('/public/delivery/calculate-price', { method: 'POST', body: { query } });

export const fetchPublicPricing = (): Promise<DeliveryPricing> => apiRequest<DeliveryPricing>('/public/delivery/pricing');

export const fetchDeliveryPricing = (): Promise<DeliveryPricing> => apiRequest<DeliveryPricing>('/pricing/delivery');

export const updateDeliveryPricing = (input: Partial<DeliveryPricing>): Promise<DeliveryPricing> =>
  apiRequest<DeliveryPricing>('/pricing/delivery', { method: 'PATCH', body: input });

export const fetchZipDistances = async (search?: string): Promise<ZipDistance[]> => {
  const query = search ? `?search=${encodeURIComponent(search)}` : '';
  return (await apiRequest<{ items: ZipDistance[] }>(`/pricing/zip-distances${query}`)).items;
};

export const createZipDistance = (input: ZipDistanceInput): Promise<ZipDistance> =>
  apiRequest<ZipDistance>('/pricing/zip-distances', { method: 'POST', body: input });

export const updateZipDistance = (id: string, input: Partial<ZipDistanceInput>): Promise<ZipDistance> =>
  apiRequest<ZipDistance>(`/pricing/zip-distances/${id}`, { method: 'PATCH', body: input });

export const deleteZipDistance = (id: string): Promise<void> => apiRequest<void>(`/pricing/zip-distances/${id}`, { method: 'DELETE' });
